/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedTicketResponseDto } from './pagedTicketResponseDto';


export interface PagedTicketResponseDtoPagedResultDto { 
    items?: Array<PagedTicketResponseDto> | null;
    totalCount?: number;
}

